import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  VclAlertModule,
  VclAutocompleteModule,
  VclCardTemplateModule,
  VclDatepickerModule,
  VclFormFieldModule,
  VclInputModule,
  VclModalModule,
  VclSelectModule,
} from '@voxel/community';
import { VoxelMaskModule, VoxelAccordionModule } from '@voxel/components';
import {
  VoxelCheckboxModule,
  VoxelFormFieldModule,
  VoxelInputModule,
  VoxelLinkModule,
  VoxelModalModule,
} from '@voxel/mobile';
import { LottieAnimationViewModule } from 'ng-lottie';

import { SharedModule } from '../../shared/shared.module';
import { ConfigurationValuesComponent } from '../configuration/configuration-values/configuration-values.component';
import { AccountSelectionComponent } from './account-selection/account-selection.component';
import { CaptureRoutes } from './capture.routes';
import { BackDocumentInfoComponent } from './check-document-info/back-document-info/back-document-info.component';
import { CheckDocumentInfoComponent } from './check-document-info/check-document-info.component';
import { FrontDocumentInfoComponent } from './check-document-info/front-document-info/front-document-info.component';
import { ClientDataUpdateComponent } from './client-data-update/client-data-update.component';
import { EmployedContractComponent } from './employed-contract/employed-contract.component';
import { ExpensesFormComponent } from './expenses-form/expenses-form.component';
import { FinancialIntroductionComponent } from './financial-introduction/financial-introduction.component';
import { ForeignCurrencyComponent } from './foreign-currency/foreign-currency.component';
import { ForeignProductsDetailComponent } from './foreign-products-detail/foreign-products-detail.component';
import { ForeignProductsComponent } from './foreign-products/foreign-products.component';
import { FormContactInfoComponent } from './form-contact-info/form-contact-info.component';
import { FormEmployeeComponent } from './form-employee/form-employee.component';
import { FormGoodsComponent } from './form-goods/form-goods.component';
import { FormSecondHeadlineInfoComponent } from './form-second-headline-info/form-second-headline-info.component';
import { FormUbicationInfoComponent } from './form-ubication-info/form-ubication-info.component';
import { GrayZoneComponent } from './gray-zone/gray-zone.component';
import { IdentificationSummaryComponent } from './identification-summary/identification-summary.component';
import { IncomeFormComponent } from './income-form/income-form.component';
import { IncomesSecondHeadlineComponent } from './incomes-second-headline/incomes-second-headline.component';
import { IndependentOccupationComponent } from './independent-occupation/independent-occupation.component';
import { InsurabilityComponent } from './insurability/insurability.component';
import { MaritalStatusComponent } from './marital-status/marital-status.component';
import { OccupationTcComponent } from './occupation-tc/occupation-tc.component';
import { OccupationComponent } from './occupation/occupation.component';
import { OfferComponent } from './offer/offer.component';
import { OperationCurrencyComponent } from './operation-currency/operation-currency.component';
import { PayDayFormTcComponent } from './pay-day-form-tc/pay-day-form-tc.component';
import { ResidenceAbroadComponent } from './residence-abroad/residence-abroad.component';
import { SecondHeadlineComponent } from './second-headline/second-headline.component';
import { SuccessPcoComponent } from './success-pco/success-pco.component';
import { SupportDocumentsComponent } from './support-documents/support-documents.component';
import { UpdateDataComponent } from './update-data/update-data.component';
import { EdithOffertComponent } from './edith-offert/edith-offert.component';
import { RequestConsultComponent } from './request-consult/request-consult.component';
import { VirtualCardFranchiseComponent } from './virtual-card-franchise/virtual-card-franchise.component';
import { DocumentsSendsComponent } from './documents-sends/documents-sends.component';
import { FormNationalityComponent } from './form-nationality/form-nationality.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    VclModalModule,
    VoxelLinkModule,
    VoxelModalModule,
    VoxelInputModule,
    VclDatepickerModule,
    VoxelCheckboxModule,
    VoxelFormFieldModule,
    VclAutocompleteModule,
    VclInputModule,
    VclFormFieldModule,
    VclCardTemplateModule,
    VclAlertModule,
    VoxelMaskModule,
    VoxelAccordionModule,
    CaptureRoutes,
    LottieAnimationViewModule.forRoot(),
    ReactiveFormsModule,
    VclSelectModule,
  ],
  providers: [],
  declarations: [
    IdentificationSummaryComponent,
    ResidenceAbroadComponent,
    CheckDocumentInfoComponent,
    FrontDocumentInfoComponent,
    BackDocumentInfoComponent,
    FormContactInfoComponent,
    OccupationComponent,
    FormUbicationInfoComponent,
    FinancialIntroductionComponent,
    FormEmployeeComponent,
    IndependentOccupationComponent,
    IncomeFormComponent,
    FormGoodsComponent,
    ExpensesFormComponent,
    OperationCurrencyComponent,
    ForeignCurrencyComponent,
    ForeignProductsDetailComponent,
    ForeignProductsComponent,
    InsurabilityComponent,
    MaritalStatusComponent,
    EmployedContractComponent,
    GrayZoneComponent,
    OfferComponent,
    EmployedContractComponent,
    SupportDocumentsComponent,
    MaritalStatusComponent,
    InsurabilityComponent,
    SuccessPcoComponent,
    OccupationTcComponent,
    PayDayFormTcComponent,
    ClientDataUpdateComponent,
    UpdateDataComponent,
    AccountSelectionComponent,
    SecondHeadlineComponent,
    IncomesSecondHeadlineComponent,
    FormSecondHeadlineInfoComponent,
    EdithOffertComponent,
    RequestConsultComponent,
    ConfigurationValuesComponent,
    VirtualCardFranchiseComponent,
    DocumentsSendsComponent,
    FormNationalityComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})

export class CaptureModule { }
